import { BackendApiClientPaths } from "@/managers/backend-api-client/types";
import { clientEnvModule } from "@/modules/client-env";
import { VITE_BACKEND_API_URL } from "@/modules/global-state/globalEnv";
import createClient from "openapi-fetch";

export const getBackendBaseUrl = () => {
  // Allow explicit override via environment variable
  if (VITE_BACKEND_API_URL) {
    return VITE_BACKEND_API_URL;
  }

  const isProd = clientEnvModule.isProd();
  const localBackendApiIsEnabled = clientEnvModule.localBackendApiIsEnabled();

  if (localBackendApiIsEnabled) {
    return "http://localhost:8000/api";
  }

  if (isProd) {
    return "https://api.mem.ai/api";
  }

  /**
   * Note that for now, we actually always just return the
   * production endpoint.
   *
   * In the future, once staging is in a solid state, we will
   * plan to have the frontend default to hitting the staging
   * backend.
   *
   * For now, we use production because it is expected (eg. matches
   * how we develop with mem-api, firestore, etc.)
   */
  return "https://api.mem.ai/api";
  /**
   * Staging Endpoint:
   *   return "https://backend-stg.mem.engineering/api";
   */
};

export const getBackendAssetProxyUrl = () => {
  const isProd = clientEnvModule.isProd();
  const localBackendApiIsEnabled = clientEnvModule.localBackendApiIsEnabled();

  if (localBackendApiIsEnabled) {
    return "http://localhost:8000/api/v2/assets/proxy";
  }

  if (isProd) {
    // Note that the `www` prefix is required.
    return "https://www.mem.storage/proxy";
  }

  /**
   * Note that for now, we actually always just return the
   * production endpoint.
   */
  return "https://www.mem.storage/proxy";
};

export const initializeBackendApiClient = () => {
  const baseUrl = getBackendBaseUrl();

  const apiClient = createClient<BackendApiClientPaths>({
    baseUrl,
  });

  return apiClient;
};
